import * as React from 'react';

import { FormInputs } from '@shared-ui/lodging-form';

import { getDateRangeInput, getRooms } from 'stores/adapters';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export function useFormInputs(hotelId: number, searchCriteria: SearchCriteriaModel): FormInputs {
  return React.useMemo(
    () => ({
      propertyId: String(hotelId),
      dateRange: searchCriteria ? getDateRangeInput(searchCriteria) : null,
      roomInput: searchCriteria ? getRooms(searchCriteria) : [],
    }),
    [hotelId, searchCriteria?.startDate, searchCriteria?.endDate, searchCriteria?.rooms]
  );
}
